import MSelect from './MSelect.vue';

MSelect.install = (app) => {
  app.component('MSelect', MSelect);
};

export { MSelect };
